<template>
  <div id="dashboard-log" class="container">
    <form>
      <div class="row">
        <div class="col">
          <label for="dataInicial">Data Inicial</label>
          <input
            class="form-control"
            id="dataInicial"
            type="text"
            v-model="filtro.dataInicialString"
            v-mask="'##/##/####'"
            placeholder="Data Inicial"
            style="height: 43px"
          />
        </div>

        <div class="col">
          <label for="dataFinal">Data Final</label>
          <input
            class="form-control"
            id="dataFinal"
            type="text"
            v-model="filtro.dataFinalString"
            v-mask="'##/##/####'"
            placeholder="Data Final"
            style="height: 43px"
          />
        </div>

        <div class="col my-auto">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="checkbox"
              id="inlineCheckbox1"
              v-model="filtro.todos"
            />
            <label class="form-check-label" for="inlineCheckbox1"
              >Todas as Datas</label
            >
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="checkbox"
              id="inlineCheckbox2"
              v-model="filtro.somenteAutenticado"
            />
            <label class="form-check-label" for="inlineCheckbox2"
              >Somente Autenticados</label
            >
          </div>
        </div>

        <div class="col my-auto">
          <button
            class="btn btn-info"
            style="height: unset; align-items: center"
            type="button"
            @click="filtrarResultados()"
          >
            Filtrar
          </button>
        </div>
        <div class="col my-auto">
          <button
            class="btn btn-info"
            style="height: unset; align-items: center"
            type="button"
            @click="downloadArquivo()"
          >
            Download Arquivo
          </button>
        </div>
      </div>
    </form>
    <br />
    <br />
    <banner-log-table :filtro="filtro" ref="bannerLogTable"></banner-log-table>
    <card-log-table :filtro="filtro" ref="cardLogTable"></card-log-table>
    <chamada-publica-log-table
      :filtro="filtro"
      ref="chamadaPublicaLogTable"
    ></chamada-publica-log-table>
    <modal-chamada-publica-log-table
      :filtro="filtro"
      ref="modalChamadaPublicaLogTable"
    ></modal-chamada-publica-log-table>
  </div>
</template>
<script>
import BannerLogTable from "@/modules/log/components/BannerLogTable";
import CardLogTable from "@/modules/log/components/CardLogTable";
import ChamadaPublicaLogTable from "@/modules/log/components/ChamadaPublicaLogTable";
import ModalChamadaPublicaLogTable from "@/modules/log/components/ModalChamadaPublicaLogTable";
import { logAPI } from "@/modules/log";
import { mapActions } from "vuex";
export default {
  components: {
    BannerLogTable,
    CardLogTable,
    ChamadaPublicaLogTable,
    ModalChamadaPublicaLogTable,
  },
  data() {
    return {
      filtro: {
        dataInicialString: new Date()
          .toISOString()
          .substr(0, 10)
          .split("-")
          .reverse()
          .join("/"),
        dataFinalString: "",
        somenteAutenticado: false,
        todos: false,
      },
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    filtrarResultados() {
      this.$refs.bannerLogTable.getAcessos();
      this.$refs.cardLogTable.getAcessos();
    },
    downloadArquivo() {
      this.setLoading(true);
      logAPI
        .downloadArquivo(this.filtro)
        .then((resp) => {
          const blob = new Blob([resp.data], {
            type: "application/vnd.ms-excel",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Logs.xlsx";
          link.click();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$toast.error("Erro ao obter arquivo de log");
        });
    },
  },
};
</script>
